import { useLoggerParams } from '../init/useLoggerParams';
import { calculateFocusFromRange } from '../../helpers/calculate-focus-from-range';
import { calculateRangeFromConfig } from '../../helpers/calculate-range-from-config';

/**
 * Loads the default "latest" range by clearing URL params.
 * useInitializeStream then computes the default range (last hour) and syncs to store.
 */
export function useLoadLatestRange() {
  const [, setLoggerParams] = useLoggerParams();

  return () => {
    const [from, to] = calculateRangeFromConfig({}, new Date());
    const [focusStart] = calculateFocusFromRange([from, to], { mode: 'end' });

    setLoggerParams({
      from,
      to,
      cursor: null,
      selection: null,
      focusStart,
    });
  };
}
